<template>
    <div>
        <div v-if="discountAdvantagesDto">
            <div class="row bg-greige mx-0 mb-2 mb-md-3">
                <div class="col-12">
                    <div class="d-flex advantage-column p-1 align-items-center">
                        <span
                            class="icon icon-phone-fund-euro text-primary font-size-30 px-2"
                            aria-hidden="true"
                        />
                        <p class="h4 mb-0 mw-100 mobile-text-center">
                            <span v-msh-html="discountAdvantagesDto.offerDescriptionText" class="offer-text" />
                            <span v-msh-html="discountAdvantagesDto.yearlyDiscountsInfoText" class="break-text" />
                        </p>
                        <button
                            class="btn btn-secondary ms-auto flex-shrink-0 d-flex justify-content-center align-items-center ms-2 me-2 w-200 mobile-max-width"
                            data-bs-toggle="modal"
                            :data-bs-target="'#' + discountAdvantagesDto.discountAdvantagesPopin.id"
                            data-oevent-category="vers_popin"
                            data-oevent-action="en_savoir_plus"
                            data-oevent-label="bannière_remise_client_internet"
                        >
                            {{ discountAdvantagesDto.buttonLabel }}
                        </button>
                    </div>
                </div>
            </div>
            <discount-advantages-popin :dto-from-object="discountAdvantagesDto.discountAdvantagesPopin" />
        </div>

        <div
            v-else
            class="d-flex align-items-center justify-content-center px-1 py-2 py-lg-1 bg-greige"
        >
            <div v-if="openCustomerDto">
                <strong v-msh-html="openCustomerDto.text" data-cs-encrypt />
                <div v-msh-html="openCustomerDto.subTitle" />
            </div>
            <template v-else>
                <div class="me-1">
                    <strong v-msh-html="switchOpen.label" />
                    <div v-msh-html="switchOpen.subTitle" />
                </div>
                <ob1-switches
                    :data-test-id="'checkbox-' + switchOpen.switchDto.id"
                    :switches-d-t-o="switchOpen.switchDto"
                    @change="handleSwitch($event, switchOpen.switchDto.checked)"
                />
            </template>
        </div>
        <ob1-snack-bar
            id="snackbar"
            ref="snackbar"
            :label="snackbarMessage"
        />
    </div>
</template>
<script>

import DiscountAdvantagesPopin from "../../../../common/advantages/DiscountAdvantagesPopin.vue";

export default {
    name:"SwitchLiveBoxCustomer",
    components: {DiscountAdvantagesPopin},
    props: {
        switchOpen: {
            type: Object,
            default: null
        },
        openCustomerDto: {
            type: Object,
            default: null
        },
        discountAdvantagesDto: {
          type: Object,
          required: false,
          default: null
        }
    },
    data() {
        return {
            snackbarMessage: ""
        }
    },
    methods: {
        handleSwitch(id, checked) {
            if (this.switchOpen !== undefined) {
                const switchDto = this.switchOpen.switchDto
                if (switchDto.checked) {
                    this.snackbarMessage = this.switchOpen.snackBarMessagesDto.yesMessage;
                    this.showSnackBar();
                    Tms.link({
                        category: switchDto.yesTmsDTO.tagZone,
                        action: switchDto.yesTmsDTO.tagName,
                        label: switchDto.yesTmsDTO.tagTarget
                    });
                } else {
                    this.snackbarMessage = this.switchOpen.snackBarMessagesDto.noMessage;
                    this.showSnackBar();
                    Tms.link({
                        category: switchDto.noTmsDTO.tagZone,
                        action: switchDto.noTmsDTO.tagName,
                        label: switchDto.noTmsDTO.tagTarget
                    });
                }
            }
            this.$emit('switch', {id: id, checked: checked});
        },
        showSnackBar() {
            const snackbar = this.$refs.snackbar;
            if (snackbar) {
                snackbar.show();
            }
        },
    }
}
</script>
<style lang="scss">
@import 'ob1_common';
@import 'ob1_variables';

.items-list-item, .ob1-item-card {
    max-width: px-to-rem(525);
}
.ob1-switch .toggle .off {
    color: white !important;
}
.ob1-switch .toggle {
    background: #555 !important;
    border: 2px solid #555 !important;
}
.ob1-switch .checkbox:checked + .toggle {
    background: #3de35a !important;
    border-color: #3de35a !important;
}
@media (max-width: 767px) {
  .advantage-column {
    flex-direction: column;
  }
  .mobile-text-center {
    text-align: center;
  }
  .mobile-max-width {
    width: 100%;
    max-width: 100%;
    margin-top: 5px;
  }
}
</style>
